import * as React from "react";

import { usePlpDataSourceProductListQuery } from "../plp-data-source-product-list-provider";

import { useProductListFredhopperRedirects } from "./product-list-fredhopper-redirects-provider";

interface ProductListLoadingStateConsumerInterface {
  isLoading: boolean;
}

const defaultValue = {} as unknown as ProductListLoadingStateConsumerInterface;

const ProductListLoadingStateContext = React.createContext(defaultValue);

export const ProductListLoadingStateProvider: React.FunctionComponent = (
  props
) => {
  const { status, isFetchingNextPage, isFetchingPreviousPage } =
    usePlpDataSourceProductListQuery();
  const { isRedirecting } = useProductListFredhopperRedirects();

  const isLoading = React.useMemo(() => {
    return !!(
      status === "loading" ||
      isFetchingNextPage ||
      isFetchingPreviousPage ||
      isRedirecting
    );
  }, [status, isFetchingNextPage, isFetchingPreviousPage, isRedirecting]);
  const value: ProductListLoadingStateConsumerInterface = React.useMemo(
    () => ({
      isLoading,
    }),
    [isLoading]
  );
  return (
    <ProductListLoadingStateContext.Provider value={value}>
      {props.children || []}
    </ProductListLoadingStateContext.Provider>
  );
};

export const useProductListLoadingState = () => {
  const value = React.useContext(ProductListLoadingStateContext);
  if (value === defaultValue) {
    throw new Error(
      "useProductListLoadingState must be used within a ProductListLoadingStateProvider"
    );
  }
  return value;
};
